import {
    ADD_FIRM,
    AVAILABLE_MANAGER_USER_ERROR, CLEAR_ERRORS,
    FIRM_ERROR,
    GET_FIRM,
    GET_FIRMS,
    GET_FIRMS_LIST,
    REMOVE_DELETE_FIRM,
    REMOVE_UPDATE_FIRM,
    SET_DELETE_FIRM_ID,
    SET_UPDATE_FIRM_ID,
    GET_FIRM_OPTIONS, 
    GET_AVAILABLE_MANAGER_USERS,
    GET_AVAILABLE_ACCOUNTANT_USERS,
    GET_AVAILABLE_STOREKEEPER_USERS,
    // Active Firm Types
    SET_ACTIVE_FIRM,
    LOAD_ACTIVE_FIRM,
    CLEAR_ACTIVE_FIRM,
    LOAD_USER_FIRMS,
    USER_FIRMS_LOADING,
    USER_FIRMS_ERROR
} from '../actions/types';

const initialState = {
    firms: [],
    firms_list: [],
    firm: {},
    available_manager_for_firms: [],
    available_accountant_for_firms: [],
    available_storekeeper_for_firms: [],
    firm_options: [],
    update_firm: null,
    delete_firm: null,
    loading: true,
    numberOfPages: 1,
    error: null,
    meta: null,
    // Active Firm State (Global Firm Switcher)
    activeFirm: null,
    userFirms: [],
    userFirmsLoading: false,
    userFirmsError: null
};

// eslint-disable-next-line

export default function (state = initialState, action) {
    const {type, payload} = action;

    switch (type) {

        case GET_AVAILABLE_MANAGER_USERS:

            return {
                ...state,
                available_manager_for_firms: payload || [],
                loading: false
            };

        case AVAILABLE_MANAGER_USER_ERROR:
            return {
                ...state,
                error: payload,
                loading: false,
            };

        case GET_AVAILABLE_ACCOUNTANT_USERS:
            return {
                ...state,
                available_accountant_for_firms: payload || [],
                loading: false,
            };

        case GET_AVAILABLE_STOREKEEPER_USERS:
            return {
                ...state,
                available_storekeeper_for_firms: payload || [],
                loading: false,
            };

        case GET_FIRM:
            return {
                ...state,
                firm: payload.data,
                error: null,
                loading: false,
            };

        case GET_FIRMS:
            return {
                ...state,
                firms: payload.data,
                numberOfPages: payload.meta.last_page,
                currentPage: payload.meta.current_page,
                error: null,
                loading: false,
            };

        case GET_FIRMS_LIST:
            return {
                ...state,
                firms_list: payload || [],
                error: null,
                loading: false,
            };

        case GET_FIRM_OPTIONS:
            return {
                ...state,
                firms: payload.data,
                error: null,
                loading: false,
            };

        case ADD_FIRM:
            return {
                ...state,
                firms: [payload],
                error: null,
                loading: false,
            };

        case REMOVE_DELETE_FIRM:
            return {
                ...state,
                delete_firm: null,
            };

        case REMOVE_UPDATE_FIRM:
            return {
                ...state,
                update_firm: null,
            };

        case SET_DELETE_FIRM_ID:

            return {
                ...state,
                delete_firm: state.firms.find((item) => item.id === payload)
            };

        case SET_UPDATE_FIRM_ID:
            return {
                ...state,
                update_firm: state.firms.find((item) => item.id === action.payload.firmID)
            };

        case FIRM_ERROR:
            return {
                ...state,
                error: payload,
                loading: false,
            };

        case CLEAR_ERRORS:
            return {
                ...state,
                error: null,
                loading: false,
            };

        // Active Firm Cases (Global Firm Switcher)
        case SET_ACTIVE_FIRM:
            return {
                ...state,
                activeFirm: payload
            };

        case LOAD_ACTIVE_FIRM:
            return {
                ...state,
                activeFirm: payload
            };

        case CLEAR_ACTIVE_FIRM:
            return {
                ...state,
                activeFirm: null
            };

        case USER_FIRMS_LOADING:
            return {
                ...state,
                userFirmsLoading: true,
                userFirmsError: null
            };

        case LOAD_USER_FIRMS:
            return {
                ...state,
                userFirms: payload || [],
                userFirmsLoading: false,
                userFirmsError: null
            };

        case USER_FIRMS_ERROR:
            return {
                ...state,
                userFirmsLoading: false,
                userFirmsError: payload
            };

        default:
            return state;
    }
}
